import type { TFunction } from 'i18next'

type ApiError = {
  response?: { status?: number; data?: { detail?: unknown } }
  code?: string
  message?: string
}

function detailText(detail: unknown): string {
  if (typeof detail === 'string') return detail.trim()
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') return item
        if (item && typeof item === 'object' && 'msg' in item) {
          return String((item as { msg?: unknown }).msg ?? '')
        }
        return ''
      })
      .filter(Boolean)
      .join(' ')
  }
  return ''
}

export function parseListingCommentError(err: unknown, t: TFunction): string {
  if (!err || typeof err !== 'object') {
    return t('listing.comments.error.unknown')
  }

  const apiErr = err as ApiError
  if (!apiErr.response) {
    if (apiErr.code === 'ERR_NETWORK' || apiErr.message === 'Network Error') {
      return t('listing.comments.error.network')
    }
    return t('listing.comments.error.network')
  }

  const status = apiErr.response.status ?? 0
  const detail = detailText(apiErr.response.data?.detail)

  if (status === 401 || detail === 'Invalid token' || detail === 'invalid_token') {
    return t('listing.comments.error.sessionExpired')
  }
  if (status === 403) {
    return t('listing.comments.error.forbidden')
  }
  if (detail === 'comment_not_found') {
    return t('listing.comments.error.commentNotFound')
  }
  if (status === 404) {
    if (detail === 'Listing not found' || detail === 'listing_not_found') {
      return t('listing.comments.error.listingNotFound')
    }
    if (detail === 'user_not_found') {
      return t('listing.comments.error.sessionExpired')
    }
    if (!detail || detail === 'Not Found') {
      return t('listing.comments.error.endpointMissing')
    }
  }
  if (detail === 'Listing not found' || detail === 'listing_not_found') {
    return t('listing.comments.error.listingNotFound')
  }
  if (detail === 'User not found' || detail === 'user_not_found') {
    return t('listing.comments.error.sessionExpired')
  }
  if (detail === 'comment_required') {
    return t('listing.comments.error.emptyComment')
  }
  if (status === 422) {
    return t('listing.comments.error.validation')
  }
  if (status >= 500) {
    return t('listing.comments.error.server')
  }

  if (detail) {
    return t('listing.comments.error.unknownDetail', { detail })
  }

  return t('listing.comments.error.unknown')
}
